import React from 'react';
import './gene.css';

const API_URL = 'https://links.szapfs.org';

function DataPage() {
    return (
        <div className="gene-page">
            <div className="gene-main-content">
                <div className="gene-glass-card" style={{ maxWidth: '1000px', margin: '0 auto' }}>
                    <div className="gene-card-title" style={{ textAlign: 'center', marginBottom: '2rem' }}>
                        Data Download
                    </div>

                    <div style={{ lineHeight: '1.8', fontSize: '1rem', color: '#374151' }}>
                        <p style={{ marginBottom: '1.5rem', fontSize: '1.1rem' }}>
                            The complete dataset from <strong>"A Whole Blood Transcriptomic Atlas Across 98 Health Conditions"</strong> is available for download.
                        </p>

                        <p style={{ marginBottom: '1.5rem' }}>
                            The archive contains the following files:
                        </p>

                        <ul style={{ paddingLeft: '2rem', marginBottom: '2rem' }}>
                            <li style={{ marginBottom: '0.5rem' }}><strong>differential_expression_genes_vs_healthy</strong> — DEG results for all conditions vs. healthy controls (~103 MB)</li>
                            <li style={{ marginBottom: '0.5rem' }}><strong>tuned_RNA_multiclass_model.pkl</strong> — Trained multi-class classification model (~200 MB)</li>
                            <li style={{ marginBottom: '0.5rem' }}><strong>shap_genes_in_models</strong> — SHAP feature importance values for prediction models (~53 KB)</li>
                            <li style={{ marginBottom: '0.5rem' }}><strong>enriched_pathway</strong> — Pathway enrichment analysis results (~864 KB)</li>
                        </ul>

                        <div style={{ textAlign: 'center', margin: '2.5rem 0' }}>
                            <a
                                href={`${API_URL}/download/all`}
                                download="wbtatlas_data.zip"
                                style={{
                                    padding: '14px 40px',
                                    fontSize: '1.1rem',
                                    fontWeight: '600',
                                    color: '#fff',
                                    background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 100%)',
                                    border: 'none',
                                    borderRadius: '50px',
                                    cursor: 'pointer',
                                    transition: 'all 0.2s ease',
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    gap: '10px',
                                    textDecoration: 'none',
                                }}
                            >
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                                    <polyline points="7 10 12 15 17 10" />
                                    <line x1="12" y1="15" x2="12" y2="3" />
                                </svg>
                                Download All Data (.zip)
                            </a>
                        </div>

                        <div style={{ marginTop: '2rem', padding: '1.5rem', backgroundColor: '#f8fafc', borderRadius: '8px', border: '1px solid #e2e8f0' }}>
                            <p style={{ margin: '0', fontSize: '0.95rem', color: '#64748b' }}>
                                The download is a single ZIP archive (<strong>wbtatlas_data.zip</strong>, ~311 MB) with all datasets in standard formats (CSV/TSV).
                                Your browser will show download progress natively.
                            </p>
                        </div>

                        <div style={{ marginTop: '1.5rem', padding: '1rem', backgroundColor: '#fef3c7', borderRadius: '6px', border: '1px solid #f59e0b' }}>
                            <p style={{ margin: '0', fontSize: '0.95rem', color: '#92400e' }}>
                                <strong>Usage License:</strong> This data is provided for academic, non-commercial use only.
                                For commercial applications or licensing inquiries, please contact the research team.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default DataPage;
